import { urqlClient } from '@/core/graphql/client';
import { Provider } from 'urql';

interface UrqlProviderProps {
  children: React.ReactNode;
}

export function UrqlProvider({ children }: UrqlProviderProps) {
  return <Provider value={urqlClient}>{children}</Provider>;
}

export default UrqlProvider;
